import { createFileRoute } from "@tanstack/react-router";
import TeamNamePageComponent from "src/features/TeamNamePageComponent";

export const Route = createFileRoute("/create/_layout/name")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <TeamNamePageComponent
      chipText="Time to launch your team"
      titleText="Let's make your team official!"
      bodyText="Give your team a unique identity. Invite your team to join you in the next step."
    />
  );
}
